import { render, staticRenderFns } from "./SimInventory.vue?vue&type=template&id=3c2f04ea&"
import script from "./SimInventory.vue?vue&type=script&lang=js&"
export * from "./SimInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports